@if (featureEnabled$ | async) {
  @if (alertingFacade.topics$ | async; as topics) {
    <div class="row mb-3">
      @for (item of topics; track $index) {
        <div class="px-0 col-12 mb-4">
          <h4 class="mb-2 zero-text p-small-bold">{{ item.label }}</h4>
          <web-design-system-switch [label]="item.description" [checked]="item.value" (checkedChange)="changeSubscription(item)" />
        </div>
      }
    </div>
  }
}
